var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask--text d-inline-block",class:[_vm.$vuetify.theme.dark ? 'dark--mask' : 'white--mask', _vm.maskClass],attrs:{"id":_vm.maskTextId}},[_c('span',{style:(("opacity: " + (_vm.showText ? 1 : 0)))},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }